define('main-runner',['require','exports','module','es5-shim','es5-sham','console-polyfill','babel-polyfill','fetch-polyfill','bootstrap','durandal/system','durandal/app','durandal/viewLocator','knockout','tealium-utils','i18next','web-urls','text!../../public/common/nonLocalized.json','lib/knockout-validation/initialize','api-access','lib/auth/auth','lib/log-ajax-redirect/log-ajax-redirect','lib/ajax-failure-handler/ajax-failure-handler','lib/multivariate-testing/multivariate-testing','lib/multivariate-testing/test-configs/g2mm-scheduling-test','lib/multivariate-testing/test-configs/in-product-purchase-test','modernizr','json3','zero-clipboard','knockout.punches','ie-support'],function (require, exports, module) {
    require('es5-shim');
    require('es5-sham');
    require('console-polyfill');
    require('babel-polyfill');
    require('fetch-polyfill');

    require('bootstrap');
    require('durandal/system');
    var app = require('durandal/app');
    require('durandal/viewLocator');

    var ko = require('knockout');
    var tealiumUtils = require('tealium-utils');
    var i18n = require('i18next');
    var webUrls = require('web-urls');
    var nonLocalizedJson = require('text!../../public/common/nonLocalized.json');
    var initializeValidation = require('lib/knockout-validation/initialize');
    var apiAccess = require('api-access');
    var auth = require('lib/auth/auth');
    var logAjaxRedirect = require('lib/log-ajax-redirect/log-ajax-redirect');
    var handleAjaxFailure = require('lib/ajax-failure-handler/ajax-failure-handler');
    var multivariateTesting = require('lib/multivariate-testing/multivariate-testing');
    var g2mmSchedulingTest = require('lib/multivariate-testing/test-configs/g2mm-scheduling-test');
    var inProductPurchaseTest = require('lib/multivariate-testing/test-configs/in-product-purchase-test');

    require('modernizr');
    require('json3');
    require('zero-clipboard');
    require('knockout.punches');
    require('ie-support');

    var configureApiAccess = function () {
        var token = auth.setUpToken();

        apiAccess.configure({
            handleAjaxFailure: logAjaxRedirect(handleAjaxFailure),
            token: token,
            headers: { ClientName: 'meeting-frontend' }
        });

        tealiumUtils.setupTealium(token);
    };

    function main() {
        /**
         * Only set debug=true during development builds. The requirejs optimizer will remove anything between the
         * //excludeStart and excludeEnd when the condition is true. Pragmas are set in requirejs config
         * https://github.com/jrburke/r.js/blob/master/build/example.build.js
         */
        // >>excludeStart("debug", pragmas.hideDebugMessagesOnBuild);
        // uncomemnt this line if you need to debug something in the lifecycle of components
        // WARNING: it generates a lot of output on the console

         // system.debug(true);

        // >>excludeEnd("debug");

        // Global Knockout is required to handle Embedded Launcher state and instruction changes
        window.ko = ko;

        /*
         * Add additional configuration here that is not possible in config.js.
         * For network resources, add config.js: "'example-path': 'empty:'" so it is not included in the optimizer.
         */
        requirejs.config({
            paths: {
                launch: webUrls.get('launcherSvcUrl') + '/launcher2/static/scripts/app/launcher'
            }
        });

        // Start Mixpanel: With persistence in localStorage to avoid cookie over-run
        window.mixpanel.init(webUrls.get('mixpanel.apiToken'), {persistence: 'localStorage'});

        // TODO Rename weburls.json.template to properties.json.template in a seperate commit

        ko.punches.enableAll();
        ko.punches.attributeInterpolationMarkup.enable();

        ko.filters.webUrls = function (key) {
            return webUrls.get(key);
        };

        ko.subscribable.fn.inputFilter = function (search, property) {
            return ko.computed(function () {
                // search and property could be observables
                var searchValue = ko.unwrap(search).toString().toLowerCase();
                var prop = ko.unwrap(property);
                return ko.utils.arrayFilter(this(), function (item) {
                    var itemValue;
                    if (prop) {
                        // item[prop] could be an observable
                        itemValue = ko.unwrap(item[prop]).toString().toLowerCase();
                    } else {
                        itemValue = item.toString().toLowerCase();
                    }
                    return itemValue.indexOf(searchValue) > -1;
                });
            }, this);
        };

        var nonLocalizedParsed = JSON.parse(nonLocalizedJson);
        ko.filters.nonLocalized = function (key) {
            return nonLocalizedParsed.products[key];
        };

        // Activate Bootstrap tooltips
        $('body').tooltip({
            container: 'body',
            html: true,
            selector: '[data-toggle="tooltip"]'
        });

        app.title = 'GoToMeeting';

        app.configurePlugins({
            router: true,
            dialog: true,
            widget: true
        });

        configureApiAccess();

        app.start().then(function () {
            var i18nOptions = {
                fallbackLng: 'en',
                resGetPath: '/public/locales/__lng__/__ns__.json',
                ns: 'web-common'
            };

            i18n.init(i18nOptions, function () {
                ko.filters.i18n = function () {
                    return i18n.t.apply(null, Array.prototype.slice.call(arguments, 0));
                };

                // initialize knockout validation before the router
                // initializes otherwise, the validation get's the wrong settings
                initializeValidation();

                multivariateTesting.initialize([g2mmSchedulingTest, inProductPurchaseTest]);

                // set a maximum timeout of 15sec for any ajax request
                // so we don't hang forever if some dependant service is down
                // and we can present some error or take some action.
                $.ajaxSetup({timeout: 15000});

                app.setRoot('router/router');
            });
        });
    }

    module.exports = main;
});

